import { Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';

export const Tag = forwardRef<
  HTMLDivElement,
  {
    icon?: string;
    content: string;
    variant?: 'primary' | 'secondary';
    disabled?: boolean;
    noWrap?: boolean;
  }
>(
  (
    {
      icon,
      content,
      variant = 'primary',
      disabled = false,
      noWrap = false,
      ...rest
    },
    ref
  ) => {
    // adding typography manually for cases where it's being overridden by accordionSummary
    // once fixing accordionSummary, we can stay with the typography variant (subtitle2/body2)
    const typographySx = {
      color:
        variant === 'secondary' || disabled
          ? 'var(--mui-palette-text-secondary)'
          : 'var(--mui-palette-text-primary)',
      fontWeight: '400 !important',
    };

    return (
      <Stack
        direction='row'
        {...rest}
        ref={ref}
        className='px-[8px] py-[3px] rounded-[4px] flex-inline vertical-align-middle'
        sx={{
          alignItems: 'center',
          gap: '4px',
          width: 'fit-content',
          ...typographySx,
          backgroundColor: disabled
            ? 'var(--mui-palette-background-disabled)'
            : 'transparent',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: disabled
            ? 'transparent'
            : variant === 'primary'
              ? 'var(--mui-palette-primary-main)'
              : 'var(--mui-palette-divider)',
        }}
      >
        {icon && <i className={icon} />}
        <Typography
          noWrap={noWrap}
          sx={{
            wordBreak: noWrap ? undefined : 'break-all',
            ...typographySx,
          }}
          variant={variant === 'primary' ? 'subtitle2' : 'body2'}
        >
          {content}
        </Typography>
      </Stack>
    );
  }
);
